import { type CSSProperties, type NestedCSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../../core/styles.constants';
import DashboardTheme from '../../statistics/dashboard/dashboard-theme';
import { inkFor } from '../../../core/admin-surface.styles';

// Chrome for the read-only "linked facilities" view on the office detail page, following the
// approved facilities mockup. The card shell, search field and group heads come from
// `core/admin-surface.styles`; what this mockup adds — type chips and facility tiles — lives here.

export const chipRow: CSSProperties = {
  display: 'flex',
  gap: 6,
  flexWrap: 'wrap',
};

export const chip = (active: boolean): NestedCSSProperties => ({
  border: `1px solid ${active ? StyleConstants.DARK_BLUE_COLOR : DashboardTheme.gray300}`,
  background: active ? StyleConstants.DARK_BLUE_COLOR : StyleConstants.WHITE_COLOR,
  color: active ? StyleConstants.WHITE_COLOR : DashboardTheme.gray700,
  borderRadius: 16,
  padding: '5px 12px',
  fontFamily: DashboardTheme.bodyFontFamily,
  fontSize: 12.5,
  fontWeight: 600,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  $nest: {
    '&:hover': {
      background: active ? StyleConstants.DARK_BLUE_COLOR : DashboardTheme.gray50,
    },
  },
});

export const body: CSSProperties = {
  padding: 20,
};

export const groupIcon = (accent: string): CSSProperties => ({
  color: inkFor(accent),
  lineHeight: 0,
  display: 'flex',
});

export const grid = (isMobile: boolean): CSSProperties => ({
  display: 'grid',
  gap: 16,
  gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(240px, 1fr))',
});

export const facilityCard: CSSProperties = {
  background: DashboardTheme.gray50,
  border: `1px solid ${DashboardTheme.gray200}`,
  borderRadius: 14,
  padding: 20,
};
